import React from 'react';
import CountUp from 'react-countup';
import { Tooltip } from 'primereact/tooltip';

function CapitalSummaryCard({ title, value, type = 'neutral', tooltip }) {
    const formattedValue = Math.abs(value).toFixed(2);
    const valueClass = `value ${type}`;
    const cardId = `card-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    
    return (
        <div className="capital-summary-card-wrapper">
            <div 
                className="capital-summary-card" 
                id={cardId} 
                data-pr-tooltip={tooltip}
                data-pr-position="top"
                data-pr-at="center top+10"
                data-pr-my="center bottom"
            >
                <h3>{title}</h3>
                <div className={valueClass}>
                    <CountUp
                        start={0}
                        end={Number(formattedValue)}
                        duration={1.5}
                        separator=","
                        decimals={2}
                        prefix="$"
                    />
                </div>
            </div>
            <Tooltip 
                target={`#${cardId}`}
                position="top" 
                mouseTrack={false}
                mouseTrackTop={10}
                showDelay={50}
                hideDelay={100}
            />
        </div>
    );
}

export default CapitalSummaryCard; 